<div class="subscriber">
  <div #subscriberDiv></div>
</div>
